<template>
  <div class="search-button">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SearchButton'
}
</script>

<style scoped>
  .search-button >>> .ant-btn-group:not(:last-child) {
    margin-right: 8px;
  }

  .search-button >>> .ant-btn-group {
    display: inline-block;
    margin-bottom: 10px;
  }
</style>
